// --------------------------------------------------------
// SUCCESS MODAL - SuccessModal
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import Modal from '@mui/material/Modal'
import { GenericSolidButton } from '../UI/buttons/Button.styled'
import { H2 } from '../UI/generalLayout/Layout.styled'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { ButtonAreaContainer, ModalContainer, ModalContentContainer } from './SuccessModal.styled'
import Colors from '../../constants/Colors'

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// SUCCESS MODAL INTERFACE
// --------------------------------------------------------

interface ISuccessModal {
    visible: boolean;
    Icon: any;
    onVoltar: any;
    modalMsg: string;
    BtnText?: string;
}
/**
/**
 * A component that renders a SuccessModal.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const SuccessModal = ({visible, onVoltar, modalMsg ='', Icon, BtnText = ''}: ISuccessModal) => {
    // --------------------------------------------------------
    // SUCCESS MODAL PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Modal
                open={visible}
            >
                <ModalContainer isMobile={isMobile}>
                    <ModalContentContainer isMobile={isMobile}>
                        <Icon />
                        <H2 color="white">{modalMsg}</H2>
                        <ButtonAreaContainer>
                            <GenericSolidButton
                                color={Colors.SPM50}
                                inverted
                                onClick={onVoltar}
                            >
                              {BtnText !== "" ?  BtnText : 'Fechar'}
                            </GenericSolidButton>
                        </ButtonAreaContainer>
                    </ModalContentContainer>
                </ModalContainer>
            </Modal>
        </>
    )
    // --------------------------------------------------------
}

export default SuccessModal